import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage, InactiveAccountPage } from '../../modules/auth';
import StudentDashboardPage, { SubjectPerStudentPage, StudentProfilePage } from '../../modules/StudentDashboard';
import UserProfilePage from '../../modules/UserProfile';
import DashboardPage from '../../modules/Dashboard';
import TeachersPage, { TeacherProfilePage } from '../../modules/Teacher';
import SubjectsPage from '../../modules/Subject';
import StudentsPage from '../../modules/Student';
import GradesPerSubjectPage, { GradesPage } from '../../modules/GradesPerSubject';
import AdvisoryPage from '../../modules/Advisory';
import AttendanceSummaryPage from '../../modules/AttendanceSummary';
import ClassSecretaryPage, { ClassSecretaryAttendancePage } from '../../modules/ClassSecretary';
import SecretaryAssignmentPage from '../../modules/SecretaryAssignment';
import RoleGuard from '../guards/RoleGuard';
import { ROLES } from '../../shared/constant/roles';

const STAFF_ROLES = [ROLES.TEACHER, ROLES.ADMIN, ROLES.SUPER_ADMIN];

function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/user-profile" element={<UserProfilePage />} />

        <Route element={<RoleGuard allowWithoutOwnLogin />}>
          <Route path="/inactive-account" element={<InactiveAccountPage />} />
        </Route>

        <Route element={<RoleGuard allowedRoles={STAFF_ROLES} />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/dashboard/teachers" element={<TeachersPage />} />
          <Route path="/dashboard/students" element={<StudentsPage />} />
          <Route path="/dashboard/subjects" element={<SubjectsPage />} />
        </Route>

        <Route element={<RoleGuard allowedRoles={[ROLES.TEACHER]} />}>
          <Route path="/dashboard/grades" element={<GradesPage />} />
          <Route path="/dashboard/advisory" element={<AdvisoryPage />} />
          <Route path="/dashboard/grades/:subjectId" element={<GradesPerSubjectPage />} />
          <Route path="/dashboard/profile" element={<TeacherProfilePage />} />
        </Route>

        <Route element={<RoleGuard allowedRoles={[ROLES.TEACHER, ROLES.ADMIN, ROLES.SUPER_ADMIN]} />}>
          <Route path="/dashboard/attendance-summary" element={<AttendanceSummaryPage />} />
        </Route>

        <Route element={<RoleGuard allowedRoles={[ROLES.ADMIN, ROLES.SUPER_ADMIN]} />}>
          <Route path="/dashboard/secretary-assignment" element={<SecretaryAssignmentPage />} />
        </Route>

        <Route element={<RoleGuard allowedRoles={[ROLES.STUDENT]} />}>
          <Route path="/student-dashboard" element={<StudentDashboardPage />} />
          <Route path="/student-dashboard/subjects/:subjectId" element={<SubjectPerStudentPage />} />
          <Route path="/student-dashboard/profile" element={<StudentProfilePage />} />
          <Route path="/student-dashboard/secretary" element={<ClassSecretaryPage />} />
          <Route path="/student-dashboard/secretary/:subjectId" element={<ClassSecretaryAttendancePage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;
